import React from "react";
import { SANS_2, colors, UI_BODY_SEMIBOLD_SM_DF, UI_BODY_SM_DF, colors2 } from "oolib";
import { createContentCardDate } from "../../../../../../../../../../utils/momentManipulate";
import { __GetContentTypeConfigNew } from "../../../../../../../../../../utils/getters/gettersV2";

const { greyColor70 } = colors;

import ReactMarkdown from 'react-markdown';
import { _Locale } from "@/components/locale/Locale";
import styled from "styled-components";

const StyledMarkdown = styled(ReactMarkdown)`

`
const MarkDownRenderer = ({ children, isDate = false, className }) => {

  const dateStyles = {
    color: colors2.grey50,
    marginTop: "0.8rem"
  };

  return (
    <div style={isDate ? dateStyles : {}} className={className}>
      <ReactMarkdown
        components={{
          p: ({ children }) => <span>{children}</span>,
          strong: ({ children }) => <strong style={{ fontWeight: '600' }}>{children}</strong>
        }}
      >
        {_Locale(children)}
      </ReactMarkdown>
    </div>
  );
};

export const NotifMsgRenderer = ({ activityType, dateCreated, content }) => {
  const getNotificationText = () => {
    const contentTypeName = __GetContentTypeConfigNew(content?.contentType)?.general?.content?.singular || content?.contentType || 'content';
    const title = content?.title || 'Untitled';
    const moderatorName = content?.moderatorName || 'moderator';

    switch (activityType) {
      case "APPROVE":
        return `Your <word1: ${contentTypeName}>: <word2: **${title}**>, has been approved by the reviewer`;

      case "PUBLISH":
        return `You have been mentioned in a <word1: ${contentTypeName}>: <word2: **${title}**>, authored by <word3: ${moderatorName}>`;

      case "MODERATE_APPROVE":
        return `Your <word1: ${contentTypeName}>: <word2: **${title}**>, has been reviewed and approved by <word3: ${moderatorName}>`;

      case "TAKEN_UNDER_MODERATION":
        return `Your <word1: ${contentTypeName}>: <word2: **${title}**>, is currently under review by <word3: ${moderatorName}>`;

      case "ADD_COMMENT":
        return `New comment on <word1: **${contentTypeName}**>: <word2: **${title}**>`;

      case "MENTION_IN_COMMENT":
        return `You have been mentioned in a comment inside of a <word1: ${contentTypeName}>: <word2: **${title}**>`;

      case "ADD_REACTION":
      case "ADD_REACTION_LIKE": // purely for backwards compatibility
        return `Someone reacted to your <word1: **${contentTypeName}**>: "<word2: **${title}**>"`;

      case "DELETE":
        return `Your <word1: ${contentTypeName}>: <word2: **${title}**>, has been deleted by <word3: ${moderatorName}>`;

      case "SENT_BACK":
        return `Your <word1: ${contentTypeName}>: <word2: **${title}**>, has been sent back by <word3: ${moderatorName}>`;

      case "MOVED_TO_AWAITING_REVIEW":
        return `Your <word1: ${contentTypeName}>: <word2: **${title}**>, has been moved to awaiting review by <word3: ${moderatorName}>`;

      case "CREATE_UPDATE":
        return `There is an update on your <word1: **${contentTypeName}**>`;

      default:
        return "New type of notif msg!";
    }
  };

  return (
    <div>
      <MarkDownRenderer className={"UI_BODY_SM"}>
        {getNotificationText()}
      </MarkDownRenderer>
      
      <MarkDownRenderer isDate className={"UI_CAPTION"}>
        {createContentCardDate(dateCreated)}
      </MarkDownRenderer>
    </div>
  );
};
